import { render, staticRenderFns } from "./Vehicleapplication.vue?vue&type=template&id=12992970&scoped=true&"
import script from "./Vehicleapplication.vue?vue&type=script&lang=js&"
export * from "./Vehicleapplication.vue?vue&type=script&lang=js&"
import style0 from "./Vehicleapplication.vue?vue&type=style&index=0&id=12992970&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12992970",
  null
  
)

export default component.exports